import angular from 'angular';
import { normalizeResponseData } from './response-normalizer';

interface INormalizedErrorResponse {
  message: null | string;
  errorCode: null | string;
}

type HttpResponseData<T> = T | INormalizedErrorResponse;

angular
  .module('flowingly.services')
  .factory(
    'flowinglyHttpResponseInterceptor',
    flowinglyHttpResponseInterceptor
  );

flowinglyHttpResponseInterceptor.$inject = ['$q'];

function flowinglyHttpResponseInterceptor($q: angular.IQService) {
  return {
    response: normalizeResponse,
    responseError: normalizeResponseError
  };

  function normalizeResponse<T>(
    response: angular.IHttpResponse<HttpResponseData<T>>
  ):
    | angular.IHttpResponse<HttpResponseData<T>>
    | angular.IPromise<angular.IHttpResponse<HttpResponseData<T>>> {
    if (shouldSkipNormalization(response)) {
      return response;
    }

    const normalizedResponse = normalizeResponseData<T>(response.data);
    if (!normalizedResponse.isLegacyEnvelope) {
      return response;
    }

    if (!normalizedResponse.success) {
      response.status = response.status >= 400 ? response.status : 400;
      response.data = {
        message: normalizedResponse.errorMessage,
        errorCode: normalizedResponse.errorCode
      };
      return $q.reject(response);
    }

    response.data = normalizedResponse.payload;
    return response;
  }

  function normalizeResponseError<T>(
    rejection: angular.IHttpResponse<HttpResponseData<T>>
  ): angular.IPromise<angular.IHttpResponse<HttpResponseData<T>>> {
    if (shouldSkipNormalization(rejection)) {
      return $q.reject(rejection);
    }

    const normalizedResponse = normalizeResponseData<T>(rejection.data);
    if (normalizedResponse.isLegacyEnvelope) {
      rejection.data = {
        message: normalizedResponse.errorMessage,
        errorCode: normalizedResponse.errorCode
      };
    }

    return $q.reject(rejection);
  }

  function shouldSkipNormalization<T>(
    response: angular.IHttpResponse<HttpResponseData<T>>
  ): boolean {
    const responseType = response.config?.responseType;
    return responseType === 'blob' || responseType === 'arraybuffer';
  }
}

export type FlowinglyHttpResponseInterceptorType = ReturnType<
  typeof flowinglyHttpResponseInterceptor
>;
